/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * てのひら眼科 Patient API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import {
  useCallback
} from 'react'
import type {
  BadRequestResponse,
  InternalServerErrorResponse,
  StripeWebhook200,
  StripeWebhookBodies
} from '.././model'
import { useAPIPatientClient } from '../../apiPatientConfig';
import type { ErrorType, BodyType } from '../../apiPatientConfig';



/**
 * Stripe からの非同期イベント（特に payment_intent.succeeded）を受信し、Order を更新する。署名検証は STRIPE_WEBHOOK_SECRET で行う。Cognito 認証は不要。
 * @summary Stripe Webhook 受信
 */
export const useStripeWebhookHook = () => {
        const stripeWebhook = useAPIPatientClient<StripeWebhook200>();

        return useCallback((
    stripeWebhookBodies: BodyType<StripeWebhookBodies>,
 ) => {
        return stripeWebhook(
          {url: `/patient/api/webhook/stripe`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stripeWebhookBodies
    },
          );
        }, [stripeWebhook])
      }
    


export const useStripeWebhookMutationOptions = <TError = ErrorType<BadRequestResponse | InternalServerErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useStripeWebhookHook>>>, TError,{data: BodyType<StripeWebhookBodies>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useStripeWebhookHook>>>, TError,{data: BodyType<StripeWebhookBodies>}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      const stripeWebhook =  useStripeWebhookHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useStripeWebhookHook>>>, {data: BodyType<StripeWebhookBodies>}> = (props) => {
          const {data} = props ?? {};

          return  stripeWebhook(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StripeWebhookMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useStripeWebhookHook>>>>
    export type StripeWebhookMutationBody = BodyType<StripeWebhookBodies>
    export type StripeWebhookMutationError = ErrorType<BadRequestResponse | InternalServerErrorResponse>

    /**
 * @summary Stripe Webhook 受信
 */
export const useStripeWebhook = <TError = ErrorType<BadRequestResponse | InternalServerErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useStripeWebhookHook>>>, TError,{data: BodyType<StripeWebhookBodies>}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useStripeWebhookHook>>>,
        TError,
        {data: BodyType<StripeWebhookBodies>},
        TContext
      > => {

      const mutationOptions = useStripeWebhookMutationOptions(options);

      return useMutation(mutationOptions);
    }
    